import React, { useState, useEffect } from "react";
import { Container } from 'react-bootstrap';
import IntakeForm from "./IntakeForm";
import ParticipantsList from "./ParticipantsList";
import './Intake.css';
import { API_BASE } from "../api";

function Intake() {
  const [participants, setParticipants] = useState([]);

  const fetchParticipants = async () => {
    try {
      const response = await fetch(`${API_BASE}/deelnemers`);
      if (response.ok) {
        const data = await response.json();
        // sort all participants by registratietijd, most recent first
        const sorted = data.sort((a, b) => new Date(b.registratietijd) - new Date(a.registratietijd));
        setParticipants(sorted);
      }
    } catch (error) {
      console.error("An error occurred while fetching participants:", error);
    }
  };

  useEffect(() => {
    fetchParticipants();
  }, []);

  const handleFormSubmit = () => {
    fetchParticipants();
  };

  const handleDelete = async (id, name) => {
    if (window.confirm(`Are you sure you want to delete ${name}?`)) {
      try {
        const response = await fetch(`${API_BASE}/deelnemers/${id}`, {
          method: 'DELETE',
        });

        if (response.ok) {
          fetchParticipants();
        } else {
          console.error("Error deleting participant");
        }
    } catch (error) {
      console.error("An error occurred:", error);
    }
    }
  };

  const downloadPhoto = async (fileName, participantId) => {
    if (!fileName) return;
    try {
      const response = await fetch(`${API_BASE}/uploads/${fileName}`);
      if (!response.ok) throw new Error('Network response was not ok');
      const blob = await response.blob();
      const objectUrl = window.URL.createObjectURL(blob);
      const ext = fileName.split('.').pop();
      const idPart = participantId ? String(participantId).replace(/[^a-z0-9_\-\.]/gi, '_') : 'photo';
      const suggestedName = `${idPart}.${ext}`;
      const a = document.createElement('a');
      a.href = objectUrl;
      a.download = suggestedName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(objectUrl);
    } catch (error) {
      console.error('Error downloading photo:', error);
      alert('Er is een fout opgetreden bij het downloaden van de foto.');
    }
  };

  return (
    <Container>
      <h1>Intake</h1>
      <IntakeForm onSubmit={handleFormSubmit} />
      <ParticipantsList participants={participants} max={10} onDelete={handleDelete} />
    </Container>
  );
}

export default Intake;
